module.exports = __webpack_public_path__ + "img/jdc_logo.ec9240c3.svg";